import React, {
    forwardRef,
    useRef,
    useImperativeHandle,
    useCallback,
} from 'react';
import { noop, get, isEmpty } from 'lodash';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'components/Common/ErrorMessage';
import { useNodeContext } from 'contexts/NodeProvider';

const CheckboxWithController = forwardRef(
    (
        {
            control,
            name,
            defaultValue,
            label,
            disabled,
            onChange = noop,
            required,
            value,
            registerRef = true,
        },
        ref
    ) => {
        const _ref = useRef();
        const { nodesRef } = useNodeContext();
        useImperativeHandle(ref, () => _ref.current);
        const inputValue = isEmpty(value) ? {} : { value };
        return (
            <Controller
                control={control}
                name={name}
                defaultValue={defaultValue}
                render={({
                    field: {
                        onChange: handleChange,
                        value: rhfValue,
                        ref: rhfRef,
                    },
                    fieldState: { error },
                }) => {
                    const onRefChange = useCallback((node) => {
                        if (registerRef) {
                            _ref.current = node;
                            rhfRef = _ref;
                            if (nodesRef) {
                                nodesRef.current[name] = node;
                            }
                        }
                    }, []);
                    return (
                        <div className="checkbox-field-container">
                            <Form.Check
                                ref={onRefChange}
                                type={'checkbox'}
                                name={name}
                                id={`label-question-checkbox-${name}`}
                                label={
                                    <>
                                        {label}
                                        <span className="text-danger">
                                            {required ? ' *' : ' '}
                                        </span>
                                    </>
                                }
                                onChange={(e) => {
                                    const storeVal =
                                        e.target.checked &&
                                        (isEmpty(value)
                                            ? e.target.checked
                                            : e.target.value);
                                    handleChange(storeVal);
                                    onChange(storeVal);
                                }}
                                aria-labelledby={`label-question-checkbox-${name}`}
                                className="checkbox-text"
                                disabled={disabled}
                                data-testid={name}
                                checked={
                                    isEmpty(value)
                                        ? rhfValue
                                        : value === rhfValue
                                }
                                {...inputValue}
                            />
                            <ErrorMessage message={get(error, 'message')} />
                        </div>
                    );
                }}
                rules={{ required }}
            />
        );
    }
);
export default CheckboxWithController;
